import { type RouteRecordRaw } from 'vue-router'

export const functionRoutes: RouteRecordRaw[] = [
  {
    path: 'functions',
    component: () => import('pages/common/RouterView.vue'),
    children: [
      {
        path: '',
        name: 'admin-manage-functions',
        component: () =>
          import('pages/receiver/admin/function/ManageFunctions.vue'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          roles: ['ROLE_ADMIN', 'ADMIN_MANAGE_FUNCTIONS'],
        },
      },
      {
        path: 'edit/:id',
        name: 'admin-function-edit',
        component: () =>
          import('pages/receiver/admin/function/EditFunction.vue'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          roles: ['ADMIN_MANAGE_FUNCTIONS'],
        },
      },
      {
        path: 'arguments/:id',
        name: 'admin-function-arguments',
        component: () =>
          import('pages/receiver/admin/function/FunctionArguments.vue'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          roles: ['ADMIN_MANAGE_FUNCTIONS'],
        },
      },
      {
        path: 'documentation/:id',
        name: 'admin-function-documentation',
        component: () =>
          import('pages/receiver/admin/function/FunctionDocumentation.vue'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          roles: ['ADMIN_MANAGE_FUNCTIONS'],
        },
      },
      {
        path: 'solutions/:id',
        name: 'admin-function-solutions',
        component: () =>
          import('pages/receiver/admin/function/FunctionSolutions.vue'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          roles: ['ADMIN_MANAGE_FUNCTIONS'],
        },
      },
    ],
  },
]
